import analyticsState from '@/store/modules/analytics/state'

export default {
    getBlockchain: (state) => state.blockchain,
    getBlockchainUserSelected: (state) => state.blockchainUserSelected,
    getBlockchainError: (state) => state.blockchainError,
    getBlockchainInput: (state) => state.blockchainInput,
    getBlockchainType: (state) => {
      const input = state.blockchainInput?.trim()
      if (!input) return null

      const allCurrencies = [
        ...analyticsState.currencyList,
        ...analyticsState.essentialCurrencyList
      ]

      for (const item of allCurrencies) {
        if (item.addressRegex && new RegExp(item.addressRegex).test(input)) {
          return 'address'
        }

        if (item.txRegex && new RegExp(item.txRegex).test(input)) {
          return 'tx'
        }
      }

      return null
    },
    getBlockchainInfo: (state) => state.blockchainInfo,
    getBlockchainResponse: (state) => state.blockchainResponse,
    getBlockchainDropdown: (state) => state.blockchainDropdown,
    getBlockchainDropdownState: (state) => Object.values(state.blockchainDropdown).some(flag => flag),
    getIsResponseHasEssential: (state) => Object.values(state.blockchainResponse).some(item => item.essential === true),
    getIsResponseHasAdvanced: (state) => Object.values(state.blockchainResponse).some(item => item.essential !== true),
    anyLoaded: (state) => {
        const values = Object.values(state.blockchainResponse)
        return values.some(item => item.loading === false)
    },
    allLoaded: (state) => {
        const values = Object.values(state.blockchainResponse)
        return values.length === 0 || values.every(item => item.loading === false)
    },
    getBlockchainRequestsOpen: (state) => state.blockchainRequestsOpen,
    getSomeHasExtendedFeatures: (state) => {
        return Object.values(state.blockchainResponse || {}).some(item =>
            item.hasAlerts || item.hasCases || item.hasReports || item.isMonitoring
        )
    },
    getBlockchainRecentQueriesState: (state) => state.blockchainRecentQueriesState,
}
